import _ from "lodash";
import React from "react";

import Icon from "@components/icon";
import Lock from "@components/lock";
import VideoContainer from "@components/video-container";

export default function StyledSlider(props) {
  const {
    emblaRef,
    emblaApi,
    gridItem,
    naturalSlideHeight,
    naturalSlideWidth,
    onSetSelectedItem,
    onUnsetSelectedItem,
    selectedItem,
  } = props;

  const [prevEnabled, setPrevEnabled] = React.useState(false);
  const [nextEnabled, setNextEnabled] = React.useState(false);

  React.useEffect(() => {
    if (!emblaApi) return;

    function onSelect() {
      const index = emblaApi.selectedScrollSnap();
      const gridItemMediaObject = gridItem.gridItemMediaObjects[index];
      onSetSelectedItem(gridItemMediaObject.id);
      setPrevEnabled(emblaApi.canScrollPrev());
      setNextEnabled(emblaApi.canScrollNext());
    }

    emblaApi.on("select", onSelect);
    setPrevEnabled(emblaApi.canScrollPrev());
    setNextEnabled(emblaApi.canScrollNext());

    return () => emblaApi.off("select", onSelect);
  }, [emblaApi, gridItem.gridItemMediaObjects, onSetSelectedItem]);

  const showArrows = gridItem.gridItemMediaObjects.length > 1;

  return (
    <React.Fragment>
      <div className="ApexFull-slider">
        {!gridItem.authorized && <Lock />}
        <div
          className="embla"
          ref={emblaRef}
          style={{ aspectRatio: `${naturalSlideWidth} / ${naturalSlideHeight}` }}
        >
          <div className="embla__container">
            {_.map(gridItem.gridItemMediaObjects, (gridItemMediaObject, index) => {
              const shouldDisplay = index === 0 || (gridItem.authorized && index > 0);

              return (
                <div className="embla__slide" key={gridItemMediaObject.id}>
                  {shouldDisplay && (
                    <React.Fragment>
                      {gridItemMediaObject.isVideo && (
                        <VideoContainer
                          authorized={gridItem.authorized}
                          gridItemMediaObject={gridItemMediaObject}
                          naturalSlideHeight={naturalSlideHeight}
                          naturalSlideWidth={naturalSlideWidth}
                          onPause={onUnsetSelectedItem}
                          onPlay={onSetSelectedItem}
                          play={selectedItem === gridItemMediaObject.id}
                        />
                      )}

                      {gridItemMediaObject.isImage && (
                        <img
                          className="ApexFull-image"
                          src={gridItemMediaObject.imgixThumbnailFull}
                        />
                      )}
                    </React.Fragment>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {gridItem.authorized && showArrows && (
          <React.Fragment>
            <button
              className="ApexFull-arrow back"
              disabled={!prevEnabled}
              onClick={() => emblaApi && emblaApi.scrollPrev()}
              type="button"
            >
              <Icon name="circle-arrow-left" />
            </button>
            <button
              className="ApexFull-arrow next"
              disabled={!nextEnabled}
              onClick={() => emblaApi && emblaApi.scrollNext()}
              type="button"
            >
              <Icon name="circle-arrow-right" />
            </button>
          </React.Fragment>
        )}
      </div>
    </React.Fragment>
  );
}
